import { MenuOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, Menu } from 'antd'
import { Spacer } from 'components'
import Link from 'next/link'
import { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { useWindowSize } from 'services/hooks'

const LISTINGS_PATH = '/listings'
const USERS_PATH = '/users'
const ORDERS_PATH = '/orders'
const VOICEMAILS_PATH = '/recordings'

const LISTINGS_LABEL = 'Listings'
const USERS_LABEL = 'Users'
const ORDERS_LABEL = 'Orders'
const VOICEMAILS_LABEL = 'Voicemails | Calls'

const StyledLink = styled.a`
  font-weight: 900;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
`

const CustomDropdown = styled(Dropdown)`
  :hover {
    cursor: pointer;
  }
`

const menu = (
  <Menu>
    <Spacer size={10} />
    <Menu.Item
      key={LISTINGS_LABEL}
      data-testid={LISTINGS_LABEL}
    >
      <Link
        href={LISTINGS_PATH}
        passHref
      >
        <StyledLink>{LISTINGS_LABEL}</StyledLink>
      </Link>
    </Menu.Item>
    <Menu.Item
      key={ORDERS_LABEL}
      data-testid={ORDERS_LABEL}
    >
      <Link
        href={ORDERS_PATH}
        passHref
      >
        <StyledLink>{ORDERS_LABEL}</StyledLink>
      </Link>
    </Menu.Item>
    <Menu.Item
      key={VOICEMAILS_LABEL}
      data-testid={VOICEMAILS_LABEL}
    >
      <Link href={VOICEMAILS_PATH}>
        <StyledLink>{VOICEMAILS_LABEL}</StyledLink>
      </Link>
    </Menu.Item>
    <Menu.Item
      key={USERS_LABEL}
      data-testid={USERS_LABEL}
    >
      <Link
        href={USERS_PATH}
        passHref
      >
        <StyledLink>{USERS_LABEL}</StyledLink>
      </Link>
    </Menu.Item>
  </Menu>
)

const MoreViews = () => {
  const theme = useContext(ThemeContext)
  const { width } = useWindowSize()
  const isMobile = width && width < theme.metrics.tablet
  return (
    <CustomDropdown
      overlay={menu}
      overlayStyle={{ zIndex: isMobile ? 10002 : 10000 }}
    >
      <Avatar
        style={{ backgroundColor: theme.colors.grey, verticalAlign: 'middle' }}
        data-testid="dropDownMenu"
      >
        <MenuOutlined style={{ color: theme.colors.purple }} />
      </Avatar>
    </CustomDropdown>
  )
}

export default MoreViews
